import React, { useCallback } from 'react';
import styled from 'styled-components';

import Menu from 'antd/es/menu';
import Dropdown from 'antd/es/dropdown';

import Button from './Button';

const StyledMenu = styled(Menu)`
  width: 150px;

  & .ant-dropdown-menu-item-group {
    margin-bottom: 4px;
  }

  & .ant-menu-item-group-list .ant-menu-item {
    margin: 2px 0;
    height: 30px;
    line-height: 32px;
    padding-bottom: 0;
    padding-top: 0;
  }
`;

const DropdownMenu = ({ icon, options, value, onChange, useSubmenus = false, ...rest }) => {
  const selectedKeys = Array.isArray(value) ? value : [value];
  const onSelect = useCallback(({ key }) => {
    if (typeof onChange === 'function') {
      onChange(key);
    }
  }, [onChange]);
  
  return (
    <Dropdown
      overlay={() => (
        <StyledMenu
          selectedKeys={selectedKeys}
          onClick={onSelect}
          {...(useSubmenus ? { triggerSubMenuAction: 'hover' } : {})}
        >
          {
            options.map((option, i) => {
              if (option && Array.isArray(option.items)) {
                if (useSubmenus) {
                  return (
                    <Menu.SubMenu key={`submenu-${i}`} title={option.title}>
                      {
                        option.items.map(item => (
                          <Menu.Item key={item.value}>
                            {item.label}
                          </Menu.Item>
                        ))
                      }
                    </Menu.SubMenu>
                  );
                }
                return (
                  <Menu.ItemGroup key={i} title={option.title}>
                    {
                      option.items.map(item => (
                        <Menu.Item key={item.value}>
                          {item.label}
                        </Menu.Item>
                      ))
                    }
                  </Menu.ItemGroup>
                );
              } else {
                return (
                  <Menu.Item key={option.value}>
                    {option.label}
                  </Menu.Item>
                );
              }
            })
          }
        </StyledMenu>
      )}
      placement="bottomRight"
      {...rest}
    >
      <Button type="outlined" shape="circle" icon={icon} />
    </Dropdown>
  )
};

export default DropdownMenu;
